import React from 'react';
import './index.scss';

export default class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
    };
    this.from = this.props.from;
  }

  hide() {
    this.setState({
      visible: false,
    });
  }
  render() {
    const { okText, cancelText, okClick, visible, closeClick, cancelClick, showClose = true } = this.props;
    const elementNameMap = this.from === 'exchange' ? {
      confirm: 'exchange_popup_confirm_confirm',
      cancel: 'exchange_popup_confirm_cancel',
      close: 'exchange_popup_confirm_close',
    } : {};
    const elementType = this.from === 'exchange' ? 'exchange' : '';

    return (
      <div className={`confirmDialog ${visible ? 'show' : ''}`}>
        <div className="dialog">
          {showClose && <div className="closeWrap" onClick={closeClick} log-click-eltype={elementType} log-click-elname={elementNameMap.close}></div>}
          <div className="content">
            {this.props.children}
          </div>
          <div className="btnGroup">
            <div className="btn cancel" log-click-eltype={elementType} log-click-elname={elementNameMap.cancel} onClick={cancelClick}>{cancelText || '取消'}</div>
            <div className="btn ok" log-click-eltype={elementType} log-click-elname={elementNameMap.confirm} onClick={okClick}>{okText || '确定'}</div>
          </div>
        </div>
      </div>
    );
  }
}
